import * as types from "../types";

const initialState = {
  loading: false,
  ticket: null,
  requestDevice: null,
  error: null,
};

export default function fetchTicketReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
        requestDevice: action.payload.requestDevice,
      };

    case types.FETCH_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        ticket: action.payload.ticket,
      };

    case types.FETCH_TICKET_FAILURE:
      return {
        ...state,
        loading: false,
        ticket: null,
        requestDevice: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
